var Dato = new function(){
	this.today;

	this.findToday = function(){
		var t = new Date();
		var cd = t.getDate();
		var cm = t.getMonth()+1;
		var cy = t.getFullYear();

		if(cd<10) {
			cd='0'+cd
		}

		if(cm<10) {
			cm='0'+cm
		}

		this.today = new Date(cy+'-'+cm+'-'+cd);
	};

	this.checkExpireDate = function(item) {
		if(item.endDate) {
			if(item.endDate != false) {
				var d = new Date();
				var time = d.getTime();
				//console.log(item);
				if(item.endDate > time/1000) {
					return true;
				}
				else {
					return false;
					/*console.log('expired');
					console.log('now', time/1000);
					console.log('endDate', item.endDate);*/
				}
			}
		}
		else {
			return true;
		}
	};
};

Dato.findToday();

export default Dato;
